import { Dialog } from "@base-ui-components/react/dialog";
import { ScrollArea } from "@base-ui-components/react/scroll-area";
import { Button, Icon } from "~components/ui";
import { ButtonClearAllFilters } from "./button-clear-all-filters";
import { EventsFilterList } from "./events-filter-list";
import { useFilterEvents } from "./filter-events-context-provider";
import { useSectionEventTranslations } from "./translations-section-events-context-provider";

function EventsFilters() {
  const { t } = useSectionEventTranslations();
  const { uniqueAttendance, uniqueCountries, uniqueEventTypes } =
    useFilterEvents();

  return (
    <Dialog.Root>
      <Dialog.Trigger
        render={
          <Button variant="secondary" className="max-h-max max-w-max shrink-0">
            <Icon name="Faders" size="24" />
            <span className="sm:inline-flex">{t.filters}</span>
          </Button>
        }
      />

      <Dialog.Portal>
        <Dialog.Backdrop className="fixed inset-[0] z-[999] bg-others-white/50 backdrop-blur-sm transition-all duration-150 data-[ending-style]:opacity-0 data-[starting-style]:opacity-0" />

        <Dialog.Popup className="fixed top-[0] right-[0] z-[999] grid h-full w-full grid-rows-[auto,1fr,auto] overflow-hidden bg-others-white transition-all duration-150 sm:w-[400px] sm:max-w-[calc(100vw-3rem)] data-[ending-style]:translate-x-full data-[starting-style]:translate-x-full data-[ending-style]:opacity-0 data-[starting-style]:opacity-0 dark:outline-gray-300">
          {/* Header */}
          <div className="border-[#cfd6db] border-b px-xs py-xs">
            <Dialog.Title className="t-default-lg flex items-center justify-between gap-2xs font-bold">
              <span>{t.filters}</span>
              <ButtonClearAllFilters />
            </Dialog.Title>
          </div>

          {/* Content */}
          <ScrollArea.Root className="min-h-[0] w-full flex-1">
            <ScrollArea.Viewport className="h-full overscroll-contain focus-visible:outline focus-visible:outline-2 focus-visible:outline-secondaryButton-text">
              <div className="flex h-full flex-col divide-y divide-[#cfd6db]">
                <EventsFilterList
                  type="countries"
                  title={t.country}
                  list={uniqueCountries}
                />

                <EventsFilterList
                  type="attendance"
                  title={t.attendance}
                  list={uniqueAttendance}
                />

                <EventsFilterList
                  type="eventTypes"
                  title={t.eventType}
                  list={uniqueEventTypes}
                />
              </div>
            </ScrollArea.Viewport>
            <ScrollArea.Scrollbar className="mr-[4px] flex w-3xs justify-center rounded opacity-0 transition-opacity delay-300 data-[hovering]:opacity-100 data-[scrolling]:opacity-100 data-[hovering]:delay-0 data-[scrolling]:delay-0 data-[hovering]:duration-75 data-[scrolling]:duration-75">
              <ScrollArea.Thumb className="w-full rounded-sm bg-satellite-200" />
            </ScrollArea.Scrollbar>
          </ScrollArea.Root>

          {/* Footer */}
          <div className="mt-auto border-[#cfd6db] border-t px-sm py-md">
            <Dialog.Close
              render={
                <Button variant="secondary" className="w-full">
                  {t.close}
                </Button>
              }
            />
          </div>
        </Dialog.Popup>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

export { EventsFilters };
